export interface Anime {
  id: number;
  slug: string;
  title: string;
  cover: string;
  category: string;
  episodes: number;
  status: string;
  rating: number;
  year: number;
  season: string;
  description: string;
  tags: string[];
  views: number;
  isHot: boolean;
  isNew: boolean;
}

export interface AnimeDetail extends Anime {
  fullDescription: string;
  director: string;
  studio: string;
  voiceActors: string[];
  episodeList: { ep: number; title: string; duration: string }[];
  relatedAnime: Anime[];
  updateDay: string;
}

export interface Category {
  slug: string;
  name: string;
  icon: string;
  description: string;
  count: number;
}

export const categories: Category[] = [
  { slug: 'rexue', name: '热血', icon: 'ri-fire-line', description: '战斗、成长、友情与信念的热血篇章', count: 42 },
  { slug: 'lianai', name: '恋爱', icon: 'ri-heart-line', description: '甜蜜浪漫的青春恋爱物语', count: 38 },
  { slug: 'qihuan', name: '奇幻', icon: 'ri-magic-line', description: '异世界冒险与魔法奇幻之旅', count: 56 },
  { slug: 'gaoxiao', name: '搞笑', icon: 'ri-emotion-laugh-line', description: '轻松搞笑的日常欢乐番', count: 31 },
  { slug: 'xuanyi', name: '悬疑', icon: 'ri-search-eye-line', description: '烧脑推理与悬疑惊悚故事', count: 24 },
  { slug: 'zhiyu', name: '治愈', icon: 'ri-plant-line', description: '温暖人心的治愈系佳作', count: 29 },
  { slug: 'jizhan', name: '机战', icon: 'ri-rocket-line', description: '机甲战斗与科幻战争史诗', count: 18 },
  { slug: 'xiaoyuan', name: '校园', icon: 'ri-building-line', description: '校园青春与日常故事', count: 35 },
  { slug: 'maoxian', name: '冒险', icon: 'ri-compass-line', description: '探索未知世界的冒险之旅', count: 47 },
  { slug: 'richang', name: '日常', icon: 'ri-home-line', description: '轻松温馨的日常生活番', count: 33 },
];

export const animeList: Anime[] = [
  {
    id: 1, slug: 'jujutsu-kaisen-s2', title: '咒术回战 第二季',
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20art%20style%2C%20young%20man%20with%20white%20hair%20and%20blindfold%2C%20dynamic%20action%20pose%2C%20dark%20supernatural%20theme%2C%20vibrant%20colors%2C%20clean%20background%20with%20subtle%20gradient%2C%20anime%20key%20visual%20style&width=600&height=840&seq=anime-cover-01&orientation=portrait',
    category: 'rexue', episodes: 23, status: '已完结', rating: 9.7, year: 2023, season: '夏季',
    description: '虎杖悠仁在咒术高专的冒险继续，涉谷事变篇震撼来袭。五条悟被封印，咒术界陷入前所未有的危机。',
    tags: ['战斗', '超能力', '黑暗奇幻'], views: 1520000, isHot: true, isNew: false,
  },
  {
    id: 2, slug: 'frieren', title: '葬送的芙莉莲',
    cover: 'https://readdy.ai/api/search-image?query=Anime%20art%2C%20elf%20girl%20with%20silver%20hair%20and%20staff%2C%20fantasy%20adventure%20theme%2C%20soft%20warm%20lighting%2C%20nostalgic%20atmosphere%2C%20beautiful%20landscape%20background%2C%20gentle%20color%20palette&width=600&height=840&seq=anime-cover-02&orientation=portrait',
    category: 'maoxian', episodes: 28, status: '已完结', rating: 9.8, year: 2023, season: '秋季',
    description: '打倒魔王的勇者队伍中的魔法使芙莉莲，作为长寿的精灵，在伙伴们相继离世后踏上了"了解人类"的旅程。',
    tags: ['奇幻', '治愈', '冒险'], views: 2100000, isHot: true, isNew: false,
  },
  {
    id: 3, slug: 'oshi-no-ko-s2', title: '我推的孩子 第二季',
    cover: 'https://readdy.ai/api/search-image?query=Anime%20art%20style%2C%20beautiful%20idol%20girl%20with%20star%20eyes%2C%20stage%20performance%20theme%2C%20glamorous%20lighting%2C%20entertainment%20industry%20setting%2C%20vibrant%20sparkle%20effects%2C%20clean%20composition&width=600&height=840&seq=anime-cover-03&orientation=portrait',
    category: 'xuanyi', episodes: 13, status: '连载中', rating: 9.5, year: 2024, season: '夏季',
    description: '阿库亚和露比在演艺圈的故事继续，舞台剧篇拉开帷幕。隐藏在娱乐圈背后的真相逐渐浮出水面。',
    tags: ['偶像', '悬疑', '剧情'], views: 980000, isHot: true, isNew: true,
  },
  {
    id: 4, slug: 'spy-family-s2', title: '间谍过家家 第二季',
    cover: 'https://readdy.ai/api/search-image?query=Anime%20art%2C%20family%20of%20three%20spy%20assassin%20and%20telepath%20girl%2C%20comedic%20pose%2C%20warm%20family%20theme%2C%20pastel%20color%20palette%2C%20cute%20anime%20style%2C%20clean%20simple%20background&width=600&height=840&seq=anime-cover-04&orientation=portrait',
    category: 'gaoxiao', episodes: 12, status: '已完结', rating: 9.4, year: 2023, season: '秋季',
    description: '劳埃德、约尔和阿尼亚的伪装家庭继续上演温馨又搞笑的日常，新的危机悄然逼近。',
    tags: ['搞笑', '日常', '动作'], views: 1350000, isHot: true, isNew: false,
  },
  {
    id: 5, slug: 'horimiya-piece', title: '堀与宫村 -piece-',
    cover: 'https://readdy.ai/api/search-image?query=Anime%20art%20style%2C%20high%20school%20couple%20boy%20with%20piercings%20and%20girl%20with%20brown%20hair%2C%20romantic%20school%20setting%2C%20cherry%20blossom%20petals%2C%20soft%20warm%20colors%2C%20sweet%20atmosphere&width=600&height=840&seq=anime-cover-05&orientation=portrait',
    category: 'lianai', episodes: 13, status: '已完结', rating: 9.2, year: 2023, season: '夏季',
    description: '堀京子和宫村伊澄的校园恋爱喜剧，未能在正篇中描绘的日常故事以全新形式呈现。',
    tags: ['恋爱', '校园', '日常'], views: 820000, isHot: false, isNew: false,
  },
  {
    id: 6, slug: 'dungeon-meshi', title: '迷宫饭',
    cover: 'https://readdy.ai/api/search-image?query=Anime%20art%2C%20fantasy%20adventure%20party%20cooking%20monsters%20in%20dungeon%2C%20unique%20food%20theme%2C%20medieval%20fantasy%20setting%2C%20warm%20earthy%20colors%2C%20detailed%20character%20designs%2C%20fun%20atmosphere&width=600&height=840&seq=anime-cover-06&orientation=portrait',
    category: 'maoxian', episodes: 24, status: '已完结', rating: 9.3, year: 2024, season: '冬季',
    description: '在迷宫中冒险的莱欧斯一行人，为了拯救被红龙吃掉的妹妹，开始了"边打怪边做饭"的奇妙冒险。',
    tags: ['奇幻', '美食', '冒险'], views: 1100000, isHot: true, isNew: false,
  },
  {
    id: 7, slug: 'bocchi-the-rock', title: '孤独摇滚！',
    cover: 'https://readdy.ai/api/search-image?query=Anime%20art%2C%20pink%20haired%20shy%20girl%20holding%20guitar%2C%20rock%20band%20theme%2C%20music%20performance%2C%20energetic%20youth%20vibe%2C%20vibrant%20colors%2C%20school%20uniform%2C%20dynamic%20composition&width=600&height=840&seq=anime-cover-07&orientation=portrait',
    category: 'richang', episodes: 12, status: '已完结', rating: 9.5, year: 2022, season: '秋季',
    description: '极度社恐的少女后藤一里，通过吉他找到了属于自己的乐队和伙伴，一场青春音乐之旅。',
    tags: ['音乐', '日常', '搞笑'], views: 1800000, isHot: true, isNew: false,
  },
  {
    id: 8, slug: 'mushoku-tensei-s2', title: '无职转生 第二季',
    cover: 'https://readdy.ai/api/search-image?query=Anime%20art%20style%2C%20young%20man%20with%20brown%20hair%20in%20fantasy%20world%2C%20magic%20adventure%2C%20detailed%20medieval%20fantasy%20setting%2C%20warm%20golden%20lighting%2C%20epic%20atmosphere%2C%20rich%20background&width=600&height=840&seq=anime-cover-08&orientation=portrait',
    category: 'qihuan', episodes: 24, status: '连载中', rating: 9.1, year: 2024, season: '春季',
    description: '鲁迪乌斯在魔法大学的崭新生活，新伙伴加入，冒险仍在继续。命运的齿轮悄然转动。',
    tags: ['异世界', '冒险', '成长'], views: 890000, isHot: false, isNew: true,
  },
  {
    id: 9, slug: 'skip-and-loafer', title: '跃动青春',
    cover: 'https://readdy.ai/api/search-image?query=Anime%20art%2C%20cheerful%20countryside%20girl%20in%20school%20uniform%2C%20Tokyo%20school%20setting%2C%20spring%20cherry%20blossoms%2C%20fresh%20youthful%20atmosphere%2C%20soft%20pastel%20colors%2C%20heartwarming%20theme&width=600&height=840&seq=anime-cover-09&orientation=portrait',
    category: 'xiaoyuan', episodes: 12, status: '已完结', rating: 9.2, year: 2023, season: '春季',
    description: '从乡下考入东京名校的岩仓美津未，以纯粹的心意和努力，在校园中收获友情与成长。',
    tags: ['校园', '日常', '青春'], views: 650000, isHot: false, isNew: false,
  },
  {
    id: 10, slug: 'heavenly-delusion', title: '天国大魔境',
    cover: 'https://readdy.ai/api/search-image?query=Anime%20art%20style%2C%20post%20apocalyptic%20world%2C%20boy%20and%20girl%20traveling%20together%2C%20mysterious%20atmosphere%2C%20ruined%20city%20background%2C%20sci-fi%20elements%2C%20moody%20lighting%2C%20detailed%20scenery&width=600&height=840&seq=anime-cover-10&orientation=portrait',
    category: 'xuanyi', episodes: 13, status: '已完结', rating: 9.0, year: 2023, season: '春季',
    description: '在崩坏的世界中，少年时雄接到"带这个孩子去天国"的指令，踏上了充满未知的旅程。',
    tags: ['科幻', '悬疑', '冒险'], views: 720000, isHot: false, isNew: false,
  },
  {
    id: 11, slug: 'yuru-camp-s3', title: '摇曳露营 第三季',
    cover: 'https://readdy.ai/api/search-image?query=Anime%20art%2C%20cute%20girls%20camping%20with%20tent%20and%20campfire%2C%20beautiful%20mountain%20scenery%2C%20warm%20cozy%20atmosphere%2C%20soft%20pastel%20colors%2C%20nature%20landscape%2C%20relaxing%20vibe&width=600&height=840&seq=anime-cover-11&orientation=portrait',
    category: 'zhiyu', episodes: 12, status: '已完结', rating: 9.4, year: 2024, season: '春季',
    description: '各务原抚子和志摩凛的露营日常第三季，新的露营地，新的邂逅，治愈你疲惫的心灵。',
    tags: ['露营', '日常', '治愈'], views: 580000, isHot: false, isNew: true,
  },
  {
    id: 12, slug: '86-eighty-six', title: '86-不存在的战区-',
    cover: 'https://readdy.ai/api/search-image?query=Anime%20art%2C%20mecha%20pilot%20young%20soldiers%20in%20military%20uniform%2C%20sci-fi%20war%20theme%2C%20dramatic%20lighting%2C%20futuristic%20battlefield%2C%20emotional%20atmosphere%2C%20detailed%20mechanical%20design&width=600&height=840&seq=anime-cover-12&orientation=portrait',
    category: 'jizhan', episodes: 23, status: '已完结', rating: 9.3, year: 2021, season: '春季',
    description: '圣玛格诺利亚共和国与"无人机"军团之间的残酷战争，以及那支不存在的"86"部队的故事。',
    tags: ['机战', '战争', '剧情'], views: 950000, isHot: false, isNew: false,
  },
];

export const animeDetailMap: Record<string, AnimeDetail> = {
  'jujutsu-kaisen-s2': {
    ...animeList[0],
    fullDescription: '《咒术回战》第二季改编自芥见下下创作的同名漫画作品。本季聚焦于"怀玉·玉折"和"涉谷事变"两大篇章。在怀玉篇中，讲述了五条悟和夏油杰在高专时代的往事，揭示了两人从挚友到决裂的完整过程。涉谷事变篇则是整个咒术回战故事的转折点，五条悟被封印，咒术界陷入前所未有的混乱。虎杖悠仁、伏黑惠、钉崎野蔷薇等人在失去最强战力的情况下，必须直面前所未有的危机。本作以其出色的战斗描绘、深刻的人物塑造和紧凑的剧情节奏，成为近年来最受欢迎的少年漫画改编作品之一。',
    director: '朴性厚 / 御所园翔太',
    studio: 'MAPPA',
    voiceActors: ['榎木淳弥', '内田雄马', '濑户麻沙美', '中村悠一', '诹访部顺一'],
    episodeList: [
      { ep: 1, title: '怀玉', duration: '24分钟' },
      { ep: 2, title: '怀玉-贰-', duration: '24分钟' },
      { ep: 3, title: '怀玉-叁-', duration: '24分钟' },
      { ep: 4, title: '怀玉-肆-', duration: '24分钟' },
      { ep: 5, title: '玉折', duration: '24分钟' },
      { ep: 6, title: '这样就好', duration: '24分钟' },
      { ep: 7, title: '宵祭', duration: '24分钟' },
      { ep: 8, title: '涉谷事变', duration: '24分钟' },
      { ep: 9, title: '涉谷事变 开门', duration: '24分钟' },
      { ep: 10, title: '昏乱', duration: '24分钟' },
      { ep: 11, title: '起首雷同', duration: '24分钟' },
      { ep: 12, title: '钝刀', duration: '24分钟' },
      { ep: 13, title: '赫鳞', duration: '24分钟' },
      { ep: 14, title: '摇荡', duration: '24分钟' },
      { ep: 15, title: '摇荡-贰-', duration: '24分钟' },
      { ep: 16, title: '霹雳', duration: '24分钟' },
      { ep: 17, title: '霹雳-贰-', duration: '24分钟' },
      { ep: 18, title: '理非', duration: '24分钟' },
      { ep: 19, title: '理非-贰-', duration: '24分钟' },
      { ep: 20, title: '理非-叁-', duration: '24分钟' },
      { ep: 21, title: '变身', duration: '24分钟' },
      { ep: 22, title: '变身-贰-', duration: '24分钟' },
      { ep: 23, title: '涉谷事变 闭门', duration: '24分钟' },
    ],
    relatedAnime: [animeList[3], animeList[8], animeList[11]],
    updateDay: '每周五更新',
  },
  'frieren': {
    ...animeList[1],
    fullDescription: '《葬送的芙莉莲》改编自山田钟人原作、阿部司作画的同名漫画。故事发生在勇者一行人打倒魔王之后的世界。精灵魔法使芙莉莲在勇者辛美尔去世后，开始意识到自己对这位伙伴的了解如此之少。为了"了解人类"，她带着新伙伴踏上了追寻勇者足迹的旅程。这是一部关于时间、记忆和情感的作品，用温柔细腻的笔触描绘了长寿种族面对短暂人类生命时的感悟。本作以其独特的叙事节奏、精美的画面和深沉的情感表达，感动了无数观众，被誉为近年最优秀的治愈系奇幻作品。',
    director: '斋藤圭一郎',
    studio: 'MADHOUSE',
    voiceActors: ['种崎敦美', '市之濑加那', '小林千晃', '冈本信彦'],
    episodeList: Array.from({ length: 28 }, (_, i) => ({ ep: i + 1, title: `第${i + 1}集`, duration: '25分钟' })),
    relatedAnime: [animeList[5], animeList[7], animeList[10]],
    updateDay: '已完结',
  },
};

export const faqData = [
  { q: '樱花动漫网是免费的吗？', a: '是的！樱花动漫网所有动漫资源均免费在线观看，无需注册登录，打开即看，让每一位动漫爱好者都能轻松追番。' },
  { q: '网站多久更新一次？', a: '我们每天都会同步更新最新播出的动漫剧集，确保你能第一时间观看到最新的动漫内容。热门连载番通常在播出后数小时内即可在我们网站找到。' },
  { q: '支持哪些设备观看？', a: '樱花动漫网完美支持电脑、平板和手机等所有主流设备，自适应屏幕尺寸，让你随时随地都能畅享动漫乐趣。' },
  { q: '如何查找想看的动漫？', a: '你可以通过首页的搜索功能直接搜索动漫名称，也可以通过分类页面按类型浏览，或者查看首页的热门推荐和最新更新列表。' },
  { q: '动漫画质怎么样？', a: '我们提供高清画质的动漫资源，大多数动漫支持720P和1080P画质选择，确保给你最佳的观看体验。' },
  { q: '遇到播放问题怎么办？', a: '如果遇到播放卡顿或无法加载的情况，建议尝试切换线路或者刷新页面。如问题持续存在，可以通过联系我们页面反馈，我们会尽快处理。' },
];

export const aboutData = {
  brandIntro: '樱花动漫网成立于2018年，是国内领先的免费动漫在线观看平台。我们致力于为中文动漫爱好者提供最全面、最及时的动漫资源，涵盖热血、恋爱、奇幻、搞笑、悬疑、治愈等各类动漫作品。经过多年发展，樱花动漫网已积累了数万部动漫资源，日均服务数百万动漫爱好者。我们坚持"让每一个人都能轻松追番"的理念，不断优化用户体验，丰富内容库。',
  reputation: [
    { label: '累计用户', value: '800万+' },
    { label: '动漫资源', value: '20000+' },
    { label: '日更新量', value: '100+' },
    { label: '用户好评率', value: '98.6%' },
  ],
  contact: {
    email: 'contact@sakura-anime.com',
    wechat: 'sakura_anime_official',
    qq: '1234567890',
    address: '中国广东省广州市天河区动漫产业园区B座3层',
  },
};